import axios from "axios";

export default function ManufacturingSummaryScheduleCoverageService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/manufacturing/summary/scheduleCoverage",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
